<template lang="pug">
.vip-button-new-container(:class='classes')
  .trans-tab
    TransTab(@chooseMember="chooseMember" :markedPrice="info.original*1",
      :price="info.current*1",:signInfoDTO="info.signInfoDTO||{}" openType="toOpen")
  .open-member-des(v-if="allMonth")
    span.des-black 次月起 {{info.signInfoDTO?info.signInfoDTO.secondSignPrice:'-'}}/月续费，可关闭
  .open-member-des(v-else)
  .open-btn(v-if="unOpenShowCanBuy" @click='open(info)')
    span.symbol ¥
    span.text {{openPrice}} 立即开通
    lottie.lottie(url='https://m.hellobike.com/resource/helloyun/07177/miBR5C3_ZS.json', ref='anime')
    .toast.part.flex-mid(v-if="info.couponEndTime&&d<1&&!allMonth")
      img(src="https://m.hellobike.com/resource/helloyun/08345/74ESsSzstH.png")
      span 已优惠{{(info.original-info.current).toFixed(2) ||"-"}}元
      span ,{{h}}:{{m}}:{{s}}后失效
    .toast-short.part.flex-mid(v-if="((!info.couponEndTime)||d>=1)&&!allMonth")
      img(src="https://m.hellobike.com/resource/helloyun/08345/74ESsSzstH.png")
      span 已优惠{{(info.original-info.current).toFixed(2) ||"-"}}元
  .open-no-can-buy(v-else)  即将上线，敬请期待
  .renewal-rules
    div(@click="sign")
      img.rule-word-img(v-if="isNoSign" src="https://m.hellobike.com/resource/helloyun/08345/37EqW_CTt-.png")
      img.rule-word-img(v-else src="https://m.hellobike.com/resource/helloyun/08345/JJ8LaMe1nV.png")
      span.normal 已阅读并同意
    span.normal 购买即同意
    span.canClick(@click="goMember") 《哈啰会员服务协议》
    span.normal 与
    span.canClick(@click="goRenewal")  《自动续费协议》
</template>
<script>
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/hbridge';
import { commonGoLink } from '@/utils';
import { Storage } from '@/utils/storage';
import eventBus from '@/const/eventBus.js';
import TransTab from './transTab.vue';
import { getSource } from '../../../../utils';


export default {
  components: {
    TransTab,
    Lottie,
  },
  props: {
    info: {
      type: Object,
      default: null,
    },
    time: {
      type: Number,
      required: true,
    },
    unOpenShowCanBuy: {
      type: Boolean,
      required: true,
    },
    readSign: {
      type: Boolean,
      default: false,
    },
    isIndex: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      classes: {
        show: false,
        fixed: false,
      },
      loadingPay: false,
      env,
      d: undefined,
      h: '',
      m: '',
      s: '',
      timer: null,
      timeout: null,
      allMonth: true,
      isNoSign: true,
    };
  },
  computed: {
    openPrice() {
      if (this.allMonth) {
        return this.info.signInfoDTO ? this.info.signInfoDTO.firstSignPrice : '-';
      }
      return this.info.current || '-';
    },
  },
  watch: {
    time(val) {
      if (val) {
        this.openTime();
      }
    },
    readSign(val) {
      this.isNoSign = !val;
      eventBus.$emit('isNoSign', this.isNoSign);
    },
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_opencard_button',
      contentId: 'platform_opencard_button',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
  },
  mounted() {
    if (this.$refs.anime) {
      this.$nextTick(() => {
        this.$refs.anime.lottie.setSpeed(1.3);
      });
    }
    this.openTime();
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_deal',
      contentId: 'platform_deal',
      exposureTimes: 1,
      businessInfo: {},
    });
    const isNoSignStorge = Storage.getItem('isNoSign');
    if (isNoSignStorge === null) {
      this.isNoSign = true;
    } else {
      this.isNoSign = isNoSignStorge;
    }
    eventBus.$on('isNoSign', (msg) => {
      if (this.isIndex) {
        Storage.setItem('isNoSign', msg);
      }
      this.isNoSign = msg;
    });
  },
  destroyed() {
    this.timer = null;
    this.timeout = null;
  },
  methods: {
    sign() {
      this.isNoSign = !this.isNoSign;
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_deal',
        categoryId: 'platform',
        businessInfo: {},
      });
      eventBus.$emit('isNoSign', this.isNoSign);
    },
    goRenewal() {
      commonGoLink('https://m.hellobike.com/mf/spa/u_hywaxn/latest/MA2209193493443248207695231.html?activityCode=MA2209193493443248207695231', { isRuleLink: true });
    },
    goMember() {
      commonGoLink('https://m.hellobike.com/mf/spa/u_yewmjx/latest/MA2209283520078470713971794.html?activityCode=MA2209283520078470713971794', { isRuleLink: true });
    },
    chooseMember(type) {
      this.allMonth = type;
      this.$emit('transTab', this.allMonth ? 30 : 0, this.openPrice);
    },
    openTime() {
      const now = new Date().getTime();
      this.timeout = this.time - now;
      this.timer = setInterval(() => {
        if (this.timeout <= 0) {
          clearInterval(this.timer);
          return;
        }
        this.showTime(this.timeout);
        this.timeout -= 1000;
      }, 1000);
    },

    showTime(timeout) {
      // 后台给我的是10位 精确到秒的  所有下面我就除以了1000，不要小数点后面的
      // eslint-disable-next-line no-console
      if (timeout && timeout > 0) {
        const t = timeout;
        // eslint-disable-next-line no-console
        // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
        this.d = Math.floor(t / 1000 / 60 / 60 / 24); // 天 var d=Math.floor(t/1000/60/60/24)
        // eslint-disable-next-line no-mixed-operators
        const h = Math.floor((t / 1000 / 60 / 60) % 24);
        // 时 var h=Math.floor(t/1000/60/60%24)
        // eslint-disable-next-line no-mixed-operators
        const m = Math.floor((t / 1000 / 60) % 60); // 分 var m=Math.floor(t/1000/60%60)
        // eslint-disable-next-line no-mixed-operators
        const s = Math.floor((t / 1000) % 60); // 秒 var s=Math.floor(t/1000%60)
        // if (parseInt(d, 10) < 10) {
        //   this.d = `0${d}`;
        // } else {
        //   this.d = `${d}`;
        // }
        if (parseInt(h, 10) < 10) {
          this.h = `0${h}`;
        } else {
          this.h = `${h}`;
        }
        if (parseInt(m, 10) < 10) {
          this.m = `0${m}`;
        } else {
          this.m = `${m}`;
        }
        if (parseInt(s, 10) < 10) {
          this.s = `0${s}`;
        } else {
          this.s = `${s}`;
        }
      }
    },
    // 确定组件是否要固定在底部
    locate() {
      this.classes.fixed = true;
      this.classes.show = true;
    },
    open(val) {
      this.isNoSign = true;
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_opencard_button',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      let ubtType;
      if (this.allMonth === 30) {
        ubtType = 2;
      } else {
        ubtType = 1;
      }
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_type_choose',
        categoryId: 'platform',
        businessInfo: {
          type: ubtType,
          typeandprice: `1&${this.info.signInfoDTO.firstSignPrice};2&${this.info.current}`,
        },
      });
      if (this.isNoSign) {
        this.$emit('isNoReadSign');
      } else if (val.showPopUpWindowType !== 1) {
        this.$emit('open', null, this.allMonth ? 30 : 0, this.openPrice);
      } else {
        this.$emit('openDialog');
      }
    },
  },
};

</script>
<style lang="less" scoped>
.vip-button-new-container {
  box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.08);
  border-radius: 0.12rem 0.12rem 0 0;
  z-index: 3;
  padding: 0.16rem 0.2rem 0;
  height: 2.29rem;
  width: 100%;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  position: fixed;
  bottom: 0;

  &.show {
    opacity: 1;
  }

  &.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.25);
    border-radius: 0.12rem 0.12rem 0 0;
  }

  .open-member-des {
    margin-top: 0.08rem;
    font-size: 0.12rem;
    font-weight: 400;
    color: #242729;
    height: 0.17rem;
    width: 100%;
    text-align: center;

    .des-blue {
      color: #08f;
    }

    .des-black {
      color: #242729;
    }
  }

  .open-btn {
    position: relative;
    margin-top: 0.1rem;
    width: 100%;
    height: 0.52rem;
    box-shadow: 0 0.01rem 0.08rem 0 rgba(250, 87, 13, 0.4);
    background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
    border-radius: 0.12rem;
    text-align: center;
    line-height: 0.52rem;
    color: #fff;
    font-weight: 500;
    font-size: 0.18rem;

    .symbol {
      font-size: 0.14rem;
    }

    .lottie {
      position: absolute;
      z-index: 229;
      top: 0;
      left: 0;
      width: 3.55rem;
      height: 0.8rem;
    }

    .part {
      position: absolute;
      z-index: 2;
    }

    .toast {
      right: 0.75rem;
      top: -0.2rem;
      height: 0.33rem;
      border-radius: 0.12rem;
      // background: linear-gradient(172deg, #ffd77a 0%, #ff8b3d 100%);
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/jXF9OEVxCp.png);
      background-size: 100% 100%;
      font-size: 0.12rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 400;
      color: #793d21;
      line-height: 0.12rem;
      padding: 0.06rem 0.06rem 0.09rem 0.06rem;
      display: flex;
      justify-content: center;

      img {
        width: 0.17rem;
        height: 0.2rem;
      }
    }

    .toast-short {
      right: 50%;
      transform: translate(50%);
      top: -0.2rem;
      border-radius: 0.12rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/7QS2QQgNqA.png);
      background-size: 100% 100%;
      font-size: 0.12rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 400;
      color: #793d21;
      line-height: 0.12rem;
      padding: 0.06rem 0.08rem 0.09rem 0.08rem;
      display: flex;
      justify-content: center;

      img {
        width: 0.17rem;
        height: 0.2rem;
      }

      .bestChoose {
        height: 0.2rem;
        line-height: 0.2rem;
        width: 0.45rem;
      }
    }
  }

  .open-no-can-buy {
    margin-top: 0.1rem;
    width: 100%;
    height: 0.52rem;
    background: linear-gradient(90deg, #bec3ca 0%, #b8bfc8 100%);
    box-shadow: 0 0.01rem 0.08rem 0 rgba(0, 0, 0, 0.12);
    border-radius: 0.12rem;
    font-size: 0.18rem;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: 0.52rem;
  }

  .renewal-rules {
    margin-top: 0.2rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    color: #879099;
    text-align: center;
    display: flex;
    justify-content: center;

    .canClick {
      color: #b16652;
    }

    img.rule-word-img {
      margin-right: 0.05rem;
      width: 0.16rem;
      height: 0.16rem;
    }
  }
}
</style>
